var map = {
	"./RESPONSIBLE_AI/AI3S_d1_01.png": 4535,
	"./RESPONSIBLE_AI/AI3S_d1_02.png": 604,
	"./RESPONSIBLE_AI/AI3S_d1_03.png": 2869,
	"./RESPONSIBLE_AI/AI3S_d1_04.png": 2442,
	"./RESPONSIBLE_AI/AI3S_d1_05.png": 8003,
	"./RESPONSIBLE_AI/AI3S_d1_06.png": 2392,
	"./RESPONSIBLE_AI/AI3S_d1_10.png": 9129,
	"./RESPONSIBLE_AI/AI3S_demo_1.png": 4413,
	"./RESPONSIBLE_AI/AI3S_demo_2_computer.png": 2152,
	"./RESPONSIBLE_AI/AI3S_demo_2_paper.png": 1757,
	"./RESPONSIBLE_AI/AI3S_demo_2_shield.png": 7968,
	"./RESPONSIBLE_AI/AI3S_demo_3_alert_message.png": 4844,
	"./RESPONSIBLE_AI/AI3S_demo_3_bubble.png": 2618,
	"./RESPONSIBLE_AI/AI3S_demo_3_close_icon.png": 7368,
	"./RESPONSIBLE_AI/AI3S_demo_3_computer.png": 3791,
	"./RESPONSIBLE_AI/AI3S_demo_3_person.png": 4199,
	"./RESPONSIBLE_AI/AI3S_demo_4_computer.png": 6982,
	"./RESPONSIBLE_AI/AI3S_demo_4_fire.png": 4009,
	"./RESPONSIBLE_AI/AI3S_demo_4_light.png": 4617,
	"./RESPONSIBLE_AI/AI3S_demo_4_lock.png": 6228,
	"./RESPONSIBLE_AI/AI3S_demo_5_computer.png": 8397,
	"./RESPONSIBLE_AI/AI3S_demo_5_magnifying_glass.png": 6700,
	"./RESPONSIBLE_AI/AI3S_demo_5_stats.png": 2913,
	"./STS/STS_intro_01.png": 3343,
	"./TRANSFORMER/TRANSFORMER_intro_01.png": 5207,
	"./TURF_OPTIMIZATION/TO_DEMO_1.png": 4534,
	"./TURF_OPTIMIZATION/TO_DEMO_2_1.png": 1797,
	"./TURF_OPTIMIZATION/TO_DEMO_2_2.png": 3966,
	"./TURF_OPTIMIZATION/TO_DEMO_3_1.png": 3988,
	"./TURF_OPTIMIZATION/TO_DEMO_3_2.png": 2895,
	"./TURF_OPTIMIZATION/TO_DEMO_4_1.png": 6119,
	"./TURF_OPTIMIZATION/TO_DEMO_4_2.png": 7116,
	"./TURF_OPTIMIZATION/TO_Demo_1_name.png": 3666,
	"./TURF_OPTIMIZATION/TO_bg_1.png": 6154,
	"./TURF_OPTIMIZATION/TO_bg_2.png": 913,
	"./TURF_OPTIMIZATION/TO_bg_3.png": 7048,
	"./TURF_OPTIMIZATION/TO_bg_4.png": 6663,
	"./characters/character_1.png": 4971,
	"./characters/character_to_1.gif": 2636,
	"./characters/character_to_1.png": 3855,
	"./icons_labels/start.png": 3518,
	"./topaz.png": 4847
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8803;